"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getString = exports.setOnLanguageChangedFn = exports.reloadStrings = exports.getCurrentLanguage = exports.setCurrentLanguage = exports.addStrings = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _config = _interopRequireDefault(require("../targets/cord_sanofi/config.js"));

var _strings = _interopRequireDefault(require("../targets/cord_sanofi/strings.js"));

var _CordovaFileHelper = _interopRequireWildcard(require("../src/helpers/CordovaFileHelper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../src/helpers/DeviceInfoHelper"));

var _BuildConstants = require("../src/utils/BuildConstants");

var _LogService = require("../src/KESI2/Services/LogService");

var _MuiAlertHelper = require("../src/helpers/MuiAlertHelper");

var CURRENT_LANG;
var CROWDIN_STRINGS = {};
/**
 * Please don't add any non-generic strings to this list but rather copy strings_template.js from this folder
 * to your components folder and add the string there.
 */

var STRINGS = {
  OK: {
    de: 'OK',
    en: 'OK'
  },
  CANCEL: {
    de: 'Abbruch',
    en: 'Cancel'
  },
  BACK: {
    de: 'zurück',
    en: 'back'
  },
  RESET_APP: {
    de: 'App zurücksetzen'
  },
  INIT_OR_WAIT_FOR_SERVER: {
    de: 'Initialisierung / Warte auf Server',
    en: 'Initializing / Waiting for server'
  },
  UNZIPPING: {
    de: 'Entpacken',
    en: 'Extracting data'
  },
  PARSING: {
    de: 'Daten verarbeiten'
  },
  UPDATE_CHECK: {
    de: 'Inhalte vorbereiten'
  },
  UPDATE_NO_UPDATE: {
    de: 'Inhalt aktuell'
  },
  UPDATE_DOWNLOADING: {
    de: 'Inhalte laden'
  },
  UPDATE_PARSING: {
    de: 'Inhalte verarbeiten'
  },
  UPDATE_DONE: {
    de: 'Abgeschlossen'
  },
  ERROR: {
    de: 'Fehler',
    en: 'Error'
  },
  UNKNOWN_ERROR: {
    de: 'Unbekannter Fehler',
    en: 'Unknown Error'
  },
  ERROR_ON_CONTENT_UPDATE: {
    de: 'Beim Aktualisieren ist ein Fehler aufgetreten.',
    en: 'An error occured while updating the content.'
  },
  ERROR_LOADING_CONTENT: {
    de: 'Der Inhalt konnte nicht geladen werden. Bitte überprüfen Sie Ihre Internetverbindung oder probieren Sie es später nochmal.',
    en: 'Error loading content. Please check your internet connection or try again later.'
  },
  ERROR_LOADING_CONTENT_WITH_REASON: {
    de: 'Der Inhalt konnte nicht geladen werden. Bitte überprüfen Sie Ihre Internetverbindung oder probieren Sie es später nochmal. Grund: $0',
    en: 'Error loading content. Please check your internet connection or try again later. Reason: $0'
  },
  RESET_APP_TITLE: {
    de: 'App zurücksetzen',
    en: 'Reset App'
  },
  RESET_APP_INFO_TEXT_LINE1: {
    de: 'Sie können die gesamte App in ihren Ursprungszustand zurücksetzen.'
  },
  RESET_APP_INFO_TEXT_LINE2: {
    de: 'Dabei werden alle Daten gelöscht und sind nicht wiederherstellbar, es sei denn sie sind bereits online gespeichert.'
  },
  RESET_APP_BUTTON_TEXT: {
    de: 'Ja, jetzt alle Daten löschen'
  },
  CONTACT: {
    de: 'Kontakt: $0'
  },
  UPDATE_APP_CONTENT: {
    de: 'Inhalt aktualisieren',
    en: 'Update content'
  },
  RELOAD_APP_CONTENT: {
    de: 'Inhalt komplett neu laden',
    en: 'Reload content'
  },
  BE_PATIENT_TITLE: {
    de: 'Einen Moment noch',
    en: 'Just a second'
  },
  BE_PATIENT_MESSAGE: {
    de: 'Die Verbindung zum Server ist gerade etwas langsam. \n Gleich geht es weiter...',
    en: 'The connection to the server is currently slow. \n It\'ll go on any moment...'
  },
  RESET_VOTING_RESULTS: {
    de: 'Alle Abstimmungsergebnisse löschen',
    en: 'Delete all poll resuls'
  },
  RESET_VOTING_RESULTS_TEXT: {
    de: 'Möchten Sie wirklich alle Abstimmungsergebnisse löschen?',
    en: 'Do you really want to delete all polling results?'
  },
  UNLOCK_MASTER_FUNCTIONALITIES: {
    de: 'Masterfunktionen aktivieren'
  },
  UNLOCK_MASTER_FUNCTIONALITIES_DIALOG_TEXT: {
    de: 'Um die Masterfunktionen freizuschalten, geben Sie bitte den <b>Aktivierungscode</b> ein.'
  },
  UNLOCK_MASTER_FUNCTIONALITIES_DIALOG_TITLE: {
    de: 'Aktivieren'
  },
  UNLOCK_EXPERT_FUNCTIONALITIES: {
    de: 'Als Experte freischalten'
  },
  LOCK_EXPERT_FUNCTIONALITIES: {
    de: 'Expertenfunktion deaktivieren'
  },
  UNLOCK_EXPERT_FUNCTIONALITIES_DIALOG_TEXT: {
    de: 'Um die Expertenfunktionen freizuschalten, geben Sie bitte den <b>Aktivierungscode</b> ein.'
  },
  UNLOCK_AUTHOR_FUNCTIONALITIES_DIALOG_TEXT: {
    de: 'Um die Authorenfunktionen freizuschalten, geben Sie bitte den <b>Aktivierungscode</b> ein.'
  },
  UNLOCK_AUTHOR_FUNCTIONALITIES: {
    de: 'Als Author freischalten'
  },
  LOCK_AUTHOR_FUNCTIONALITIES: {
    de: 'Authorenfunktion deaktivieren'
  },
  UNLOCK_AUTHOR_FUNCTIONALITIES_DIALOG_TITLE: {
    de: 'Aktivieren'
  },
  UNLOCK_EXPERT_FUNCTIONALITIES_DIALOG_TITLE: {
    de: 'Aktivieren'
  },
  REMOVE_MASTER_FUNCTIONALITIES: {
    de: 'Masterfunktionen deaktivieren'
  },
  NO_OPTION_CHOSEN: {
    de: 'Bitte wählen Sie eine Antwort aus.'
  },
  NO_OPTION_CHOSEN_TITLE: {
    de: 'Keine Antwort gewählt'
  },
  CODE: {
    de: 'Aktivierungscode'
  },
  ENTER_CODE: {
    de: 'Aktivierungscode eingeben'
  },
  PASSWORD: {
    de: 'Passwort'
  },
  PASSWORD2: {
    de: 'Passwort wiederholen'
  },
  LOG_OUT: {
    de: 'Abmelden'
  },
  PASSWORD_RESET: {
    de: 'Passwort vergessen'
  },
  PASSWORD_RE_RESET: {
    de: 'Passwort erneut zurücksetzen'
  },
  FORGOT_PASSWORD: {
    de: 'Passwort vergessen'
  },
  FORGOT_USERNAME: {
    de: 'Nutzername vergessen'
  },
  USER_DATA: {
    de: 'Benutzerkonto anlegen '
  },
  USER_DATA_EXPLANATION: {
    de: 'Bitte wähle Deinen persönlichen Nutzernamen und Dein Passwort.'
  },
  REGISTER_CODE_WRONG: {
    de: 'Der Registrierungscode war falsch, bitte versuchen Sie es erneut.'
  },
  USER_NAME: {
    de: 'Nutzername'
  },
  CORRECT: {
    de: 'Richtig'
  },
  WRONG: {
    de: 'Falsch'
  },
  NEW_ROUND: {
    de: 'Neue Runde'
  },
  NETWORK_LOST: {
    de: 'Du bist nicht online.<br/>Bitte stelle eine Internetverbindung her und versuche es nochmal.'
  },
  TRY_AGAIN: {
    de: 'Nochmal versuchen',
    en: 'Try again'
  },
  LOGIN: {
    de: 'Login'
  },
  KESI_LOGIN_TEXT: {
    de: 'Bitte melde Dich mit Deinem persönlichen Nutzernamen und Passwort an.'
  },
  REGISTER: {
    de: 'Passwort'
  },
  PASSWORD_REPEAT: {
    de: 'Passwort wiederholen'
  },
  PASSWORD_ERROR: {
    de: 'Das eingegebene Passwort war leider falsch.'
  },
  PASSWORD_MATCH_ERROR: {
    de: 'Die eingegebenen Passwörter stimmen nicht überein.'
  },
  PASSWORD_SHORT: {
    de: 'Das eingegebene Passwort ist zu kurz. Bitte verwende mindestens fünf Zeichen.'
  },
  SEND_PUSH: {
    de: 'Nachricht senden'
  },
  OOPS: {
    de: 'Hoppla!'
  },
  FAILURE: {
    de: 'Meldung'
  },
  UNLOCK_TRAINER_FUNCTIONALITIES: {
    de: 'Trainerfunktionen freischalten'
  },
  UNLOCK_TRAINER_FUNCTIONALITIES_DIALOG_TEXT: {
    de: 'Um die Trainerfunktionen freizuschalten, geben Sie bitte den <b>Trainercode</b> ein.'
  },
  UNLOCK_TRAINER_FUNCTIONALITIES_DIALOG_TITLE: {
    de: 'Freigabe'
  },
  NO_BACK: {
    de: 'Der Button ist hier ohne Funktion!'
  },
  NO_BACK_TITLE: {
    de: 'Funktion nicht möglich.'
  },
  UNAUTHORIZED_MESSAGE: {
    de: 'Du hast auf einem anderen Gerät ein neues Passwort vergeben. Bitte melde Dich neu an.'
  },
  NO_GROUP_ID: {
    de: 'Es konnte keine Gruppe geladen werden. Bitte versuche es erneut'
  },
  YES: {
    de: 'Ja'
  },
  NO: {
    de: 'Nein'
  },
  RESENT_USERNAME_TITLE: {
    de: 'Nutzername versendet'
  },
  RESENT_USERNAME_TEXT: {
    de: 'Wir haben Deinen Nutzernamen an die hinterlegte E-Mail-Adresse versendet.'
  },
  RESENT_USERNAME_ERROR_TITLE: {
    de: 'Schade, beim Senden des Nutzernamens ist etwas schief gelaufen'
  },
  REQUEST_PASSWORD_ERROR_TITLE: {
    de: 'Schade, beim Zurücksetzen des Passworts ist etwas schief gelaufen'
  },
  USER_AGREEMENT_TEXT: {
    de: '<div style="text-align: left; font-size:12pt; color:#5a5a5a">' + '<p style="font-size:14pt"><h3>Definitionen</h3></p>' + '<p style="font-size:12pt">Dienstanbieter im Sinne von § 2 TMG ist<br/><br/>' + 'equeo GmbH<br/>' + 'Berlinickestrasse 11<br/>' + '12165 Berlin</p>' + '<p style="font-size:14pt"><h3>Bestimmungsgemäßer Gebrauch</h3></p>' + '<p>Die Inhalte der auf dieser Website bereitgestellten Trainingsprogramme sind ausschließlich zur innerbetrieblichen Fortbildung der Mitarbeiter des Dienstanbieters bestimmt. Der Zugang zu diesen Inhalten ist durch eine Nutzerkennung und ein individuelles Password geschützt. Das Weitergeben des Zugangs oder das – auch auszugsweise – kopieren der Inhalte ist untersagt.</p>' + '<p style="font-size:14pt"><h3>Haftung für Inhalte</h3></p>' + '<p>Die Inhalte dieser Webseite wurden sorgfältig und nach aktuellem Kenntnisstand erstellt. Die der Dienstanbieter ist für diese nur im Rahmen der allgemeinen Gesetze verantwortlich, insbesondere gemäß § 7 Abs. 1 TMG bzw. für fremde Inhalte gemäß §§ 8 bis 10 TMG. Für die fremden Inhalte ist der Dienstanbieter frühestens ab Kenntniserlangung einer konkreten&nbsp;Rechtsverletzung verantwortlich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>' + '<p style="font-size:14pt"><h3>Haftung für Links</h3></p>' + '<p>Die Trainingsinhalte enthalten Links zu Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben, weshalb wir uns von diesen distanzieren bzw. uns diese nicht zu Eigen machen. Wir übernehmen für diese fremden Inhalte keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>' + '<p style="font-size:14pt"><h3>Urheberrecht</h3></p>' + '<p>Alle in dieser App erstellten Inhalte und Werke unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Urhebers bzw. Rechteinhabers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>'
  },
  USER_AGREEMENT_TITLE: {
    de: 'Nutzungsvereinbarung'
  },
  WAITING_FOR_RESET_TEXT: {
    de: 'Schau jetzt bitte ins E-Mail-Postfach für $0<br />Wir haben dorthin eine E-Mail mit einem Link geschickt, mit dem Du Deine Passwortänderung autorisieren kannst.<br /><br /><p style="font-size: 22px; color: black"><b>Bitte lass dieses Fenster geöffnet, denn hier legst Du gleich Dein neues Passwort fest!</b></p>'
  },
  WAITING_FOR_RESET_TITLE: {
    de: 'Rücksetzlink versendet'
  },
  ALREADY_REGISTERED: {
    de: 'Ich habe schon ein Konto angelegt.'
  },
  USER_NOT_AGREED: {
    de: 'Bitte akzeptiere die Nutzungsvereinbarung um Dich zu registrieren'
  },
  REGISTER_FIELDS_EMPTY: {
    de: 'Bitte fülle alle Felder aus'
  },
  SHOW_USER_AGREEMENT: {
    de: 'Nutzungsvereinbarung anzeigen'
  },
  SHOW_IMPRINT: {
    de: 'Impressum anzeigen'
  },
  IMPRINT_TEXT: {
    de: '<div style="text-align: left; font-size:12pt; color:#5a5a5a"><p style="font-size: 16px; font-weight: bold"><strong>Impressum / Anbieterkennzeichnung</strong></p><br/>' + '<p><strong>equeo GmbH</strong></p><br/>' + '<p>Kissinger Str. 1-2<br/>' + 'D-14199 Berlin<br/>' + 'Telefon: +49 / (0) 30 6795 1116<br/>' + 'eMail: kontakt@equeo.de</p><br/>' + '<br/>' + 'V.i.S.d.Redaktion: Tim Kaufhold</p><br/>' + '<br/>' + '<p>Gesellschaft mit beschränkter Haftung, Sitz Berlin<br />' + 'Geschäftsführer: Thomas Flum<br />' + 'Amtsgericht Charlottenburg<br/>' + 'HRB 114217B<br/>' + 'USt-IdNr.: DE260909054<br/>' + 'Alle Angaben gemäß § 5 TMG</p><br/></div>'
  },
  IMPRINT_TITLE: {
    de: 'Impressum'
  },
  DATA_PRIVACY_TEXT: {
    de: '<div style="text-align: left; font-size:12pt; color:#5a5a5a">Datenschutzerklärung für diese App<br/>' + 'Wir freuen uns, dass Sie sich für diese App interessieren. Uns ist der Schutz Ihrer personenbezogenen Daten ein wichtiges Anliegen. Wir verpflichten uns daher, Ihre Privatsphäre zu schützen und Ihre Daten vertraulich und entsprechend der geltenden Datenschutzbestimmungen zu behandeln. <br/>' + 'Im Folgenden möchten wir Sie darüber informieren, welche Ihrer personenbezogenen Daten im Rahmen der Nutzung unserer App erfasst und für welche Zwecke sie genutzt werden.<br/>' + '<h3>1. Geltungsbereich</h3><br/>' + 'Diese Datenschutzbestimmungen gelten für die Verarbeitung personenbezogener Daten durch die equeo GmbH im Rahmen der Nutzung dieser App. <br/>' + '<br/>' + '<br/>' + '<h3>2. Wer ist der Verantwortliche für die Datenverarbeitung?</h3><br/>' + '<br/>' + 'equeo GmbH <br/>' + 'vertreten durch den Geschäftsführer: Thomas Flum<br/>' + 'Berlinickestraße 11<br/>' + '12165 Berlin<br/>' + '<br/>' + 'Tel. +49 30 6795 1116<br/>' + 'E-Mail: kontakt@equeo.de<br/>' + '  <br/>' + 'Internet: http://www.equeo.de/ <br/>' + '<br/>' + '<h3>3. Wer ist unser Datenschutzbeauftragter?</h3><br/>' + 'Unsere(n) Datenschutzbeauftragte(n) erreichen Sie wie folgt:<br/>' + 'Mazars Rechtsanwaltsgesellschaft mbH, Domstraße 15, 20095 Hamburg<br/>' + 'Tel: 040 288010<br/>' + 'E-Mail: datenschutz@equeo.de<br/>' + '<br/>' + '<br/>' + '<h3>4.  Welche Daten werden von uns erhoben und verarbeitet?</h3><br/>' + 'a.   Datenverarbeitung bei der Registrierung<br/>' + 'Um das Lernspiel zu nutzen, muss sich der Nutzer mit einem Spielernamen registrieren und den Zugang zu seinem so angelegten Nutzerkonto mit einem Passwort sichern. Diese Maßnahme dient dazu, es dem Nutzer zu ermöglichen, seinen Lernstand auch auf anderen Geräten einsehen zu können.<br/>' + 'Die Daten werden dabei in eine Eingabemaske eingegeben und an den Dienstleister, die equeo GmbH übermittelt und gespeichert.<br/>' + 'Eine Registrierung des Nutzers ist für die Ablage der Spielstandsdaten auf anderen Geräten des Nutzers sowie für dessen Auffindbarkeit für andere Spieler erforderlich.<br/>' + 'Zum Zeitpunkt der Registrierung werden zudem folgende Daten verarbeitet:<br/>' + '• E-Mail-Adresse<br/>' + '• Passwort für den Zugang zu Lernstandsdaten<br/>' + 'Die Angabe der E-Mail-Adresse ist im Falle des Vergessens des eigenen Passworts nötig, um das Passwort zurücksetzen zu können.<br/>' + 'Rechtsgrundlage für die Verarbeitung der Daten ist bei Art. 6 Abs. 1 lit. b) und f) DSGVO.<br/>' + 'Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind und keine anderweitige Rechtsgrundlage eingreift. Werden Sie für mehr als drei Monate nicht in der App aktiv, werden Ihre Daten anonymisiert.<br/>' + 'b. Datenverarbeitung bei der Nutzung der Quiz App<br/>' + 'Bei jedem Aufruf der verschiedenen Funktionen der App erfasst das System automatisiert Daten und Informationen des Mobilgerätes.<br/>' + 'Folgende Daten werden hierbei erhoben:<br/>' + '• IP-Adresse des Nutzers<br/>' + '• Log- und Protokolldaten<br/>' + '• Servicekennung der App<br/>' + '• Datum und Uhrzeit des Zugriffs<br/>' + 'Diese Daten werden ebenfalls in den Logfiles des Systems nach Maßgabe der DSGVO gespeichert. Eine Speicherung dieser Daten zusammen mit anderen personenbezogenen Daten des Nutzers findet nicht statt.<br/>' + 'Darüber hinaus erfasst die App anwenderspezifische Daten wie:<br/>' + '• Lernprozess und Lernstandsdaten (Bearbeitungsstände von Lernnuggets)<br/>' + '• vom Nutzer vergebenes Passwort<br/>' + '• E-Mail-Adresse zur Wiederherstellung eines verlorenen Passwortes<br/>' + '• <br/>' + 'Die vorübergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine Auslieferung der Inhalte an den Rechner oder das mobile Device des Nutzers zu ermöglichen. Hierfür muss die IP-Adresse des Nutzers für die Dauer der Nutzung der App gespeichert werden.<br/>' + 'Die Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit der App sicherzustellen. Zudem dienen die Daten zur Optimierung der App und zur Sicherstellung der Sicherheit der informationstechnischen Systeme.<br/>' + 'Als Rechtsrundlage dient Art. 6 Abs. 1 lit. b) und f) DSGVO.<br/>' + 'Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Im Falle der Erfassung der Daten zur Bereitstellung der Website ist dies der Fall, wenn die jeweilige Sitzung beendet ist.<br/>' + 'Im Falle der Speicherung der Daten in Logfiles ist dies nach spätestens sieben Tagen der Fall.<br/>' + 'Werden Sie für mehr als drei Monate nicht in der App aktiv, werden Ihre Daten anonymisiert. Die Speicherung der anonymen Lernprozessdaten erfolgt unbegrenzt.<br/>' + '<h3>5. Wie sichern wir Ihre Daten?</h3><br/>' + 'Sofern wir oder unsere Auftragsverarbeiter Ihre Daten erheben, speichern oder in sonstiger Weise verarbeiten, erfolgt dies auf besonders geschützten Servern in Rechenzentren in Deutschland. Darüber hinaus werden dort und bei unseren Dienstleistern umfangreiche technische und organisatorische Sicherheitsvorkehrungen ergriffen, die regelmäßig überprüft und dem technologischen Fortschritt entsprechend angepasst werden. <br/>' + '<h3>6. Was sind Ihre Rechte?</h3><br/>' + '<br/>' + '· Recht auf Auskunft über verarbeitete Daten (Art. 15 DSGVO i. V. m. § 83 SGB X)<br/>' + '· Recht auf Berichtigung unrichtiger Daten (Art. 16 DSGVO i. V. m. § 84 SGB X)<br/>' + '· Recht auf Löschung (Art. 17 DSGVO i. V. m. § 84 SGB X)<br/>' + '· Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO i. V. m. § 84 SGB X)<br/>' + '· Widerspruchsrecht (Art. 21 DSGVO i. V. m. § 84 SGB X)<br/>' + '· Recht auf Datenübertragbarkeit (Art. 20 DSGVO)<br/>' + '· Bei Datenverarbeitung aufgrund einer Einwilligung besteht das Recht diese mit Wir¬kung für die Zukunft jederzeit zu widerrufen.<br/>' + '<br/>' + '<br/>' + 'Für die Ausübung Ihrer Rechte können Sie sich an uns unter den oben angegebenen Kontaktdaten wenden.<br/>' + '<br/>' + 'Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche in sonstiger Weise verletzt worden sind, können Sie sich zudem bei einer Datenschutzbehörde beschweren. Die für uns zuständige Aufsichtsbehörde ist:<br/>' + '<br/>' + 'Berliner Beauftragte für Datenschutz und Informationsfreiheit<br/>' + 'Friedrichstr. 219<br/>' + 'Besuchereingang: Puttkamerstr. 16 – 18 (5. Etage)<br/>' + '10969 Berlin<br/>' + 'mailbox@datenschutz-berlin.de<br/>' + 'Stand: 14.09.2020<br/></div>'
  },
  DATA_PRIVACY_TITLE: {
    de: 'Datenschutzerklärung'
  },
  CHOOSE_NEW_PW_TITLE: {
    de: 'Passwort neu wählen'
  },
  CHOOSE_NEW_PW_TEXT: {
    de: 'Bitte gib Dein neu gewähltes Passwort in beiden Feldern ein. Durch den Klick auf „OK“ wird Dein altes Passwort durch das neue ersetzt.'
  },
  USER_WELCOME_PW_RESET_TITLE: {
    de: 'Neues Passwort aktiviert'
  },
  USER_WELCOME_PW_RESET: {
    de: 'Geschafft! Dein neues Passwort ist jetzt aktiv.'
  },
  USER_WELCOME: {
    de: '<div style="font-size:12pt; color:#5a5a5a"><p>Dein Konto wurde erfolgreich aktiviert.</p></div>'
  },
  USER_WELCOME_TITLE: {
    de: 'Willkommen'
  },
  WELCOME_USER: {
    de: 'Hallo $0!'
  },
  ONLINE_STATE_INVISIBLE: {
    de: 'Anzeigen, wenn ich online bin'
  },
  NOTIFICATION: {
    de: 'Meldung'
  },
  RESEND_TEXT: {
    de: 'Bitte gib Deine E-Mail Adresse ein, an die Deine Zugangsdaten versendet werden sollen'
  },
  RESEND_TITLE: {
    de: 'Daten zusenden'
  },
  ACTIVATION_CODE: {
    de: 'Aktivierungscode'
  },
  E_CODE_NOT_FOUND: {
    de: 'Dieser Aktivierungscode ist unbekannt.',
    en: 'Activation code unknown'
  },
  LOADING: {
    de: 'Lade',
    en: 'Loading',
    it: 'Scaricando',
    fr: 'Charger',
    es: 'Cargar'
  },
  PASSWORD_RESET_TEXT: {
    de: 'Bitte gib den Nutzernamen ein, den Du bei der Aktivierung Deines Kontos gewählt hast.'
  },
  USERNAME_RESEND_TEXT: {
    de: 'Bitte gib Deine E-Mailaddresse ein.'
  },
  USERNAME_RESEND: {
    de: 'Nutzername vergessen'
  },
  MAIL: {
    de: 'E-Mail Adresse'
  },
  LECTURE_PROGRESS: {
    de: 'Erledigt',
    en: 'Done'
  },
  CHECK_ANSWER: {
    de: 'ÜBERPRÜFEN',
    en: 'CHECK'
  },
  LOGIN_SUCCESSFUL_TITLE: {
    de: 'Login erfolgreich',
    en: 'Login successful'
  },
  LOGIN_SUCCESSFUL_MESSAGE: {
    de: 'Sie sind nun eingeloggt.',
    en: 'You are now logged in'
  },
  // ***************************************************************************
  // ERGO
  // ***************************************************************************
  ENTER_ACTIVATION_CODE_TITLE: {
    de: 'Aktivierungscode eingeben',
    en: 'Enter activation code'
  },
  ENTER_ACTIVATION_CODE: {
    de: 'Bitte geben Sie Ihren Aktivierungscode ein',
    en: 'Please enter your activation code'
  },
  ENTER_USER_DATA: {
    de: 'Bitte geben Sie Ihre Benutzerdaten ein'
  },
  FILL_ALL_FIELDS: {
    de: 'Bitte füllen Sie alle benötigten Felder aus'
  },
  LEVEL_NOT_ALLOWED: {
    de: 'Bitte wählen Sie eine Stufe zwischen 1 und 6'
  },
  ENTER_PASSWORDS_TITLE: {
    de: 'Passwort festlegen'
  },
  ENTER_PASSWORDS: {
    de: 'Bitte legen Sie Ihr Passwort fest (mindestens 6 Zeichen)'
  },
  USER_PASSWORD: {
    de: 'Passwort'
  },
  USER_PASSWORD_REPEAT: {
    de: 'Passwort wiederholen'
  },
  GENERATE_REQUEST_CODE: {
    de: 'Neuen Aktivierungscode anfordern'
  },
  PUSH_MESSAGE: {
    de: 'Nachricht eingeben'
  },
  CONFIRM: {
    de: 'Bestätigen'
  },
  PLEASE_ACTIVATE_APP: {
    de: 'Bitte aktivieren Sie Ihre App'
  },
  SEND_CODE_WITH_MAIL: {
    de: 'Code per Mail versenden'
  },
  TILE_ANIMATION_ACTIVE: {
    de: 'Animierte Kacheln?'
  },
  ACCESSIBILITY_TITLE: {
    de: 'Erklärung zur Barrierefreiheit'
  },
  START_NOW: {
    de: 'Jetzt starten'
  },
  JUMP_OVER: {
    de: 'Überspringen'
  },
  SHOW_DATA_PRIVACY: {
    de: 'Datenschutz anzeigen'
  },
  QR_LOGIN_TEXT: {
    de: 'Du hast einen QR Code? Dann scann diesen jetzt hier ein, um Dich einzuloggen.'
  },
  QR_LOGIN_TITLE: {
    de: 'QR Code scannen'
  },
  // ***************************************************************************
  // ERV
  // ***************************************************************************
  REGISTER_USE_LOGIN: {
    de: 'Einloggen',
    en: 'Login'
  },
  REGISTER_USE_REGISTER: {
    de: 'Registrieren',
    en: 'Register'
  },
  REGISTER_LOGIN_OR_REGISTER_MESSAGE: {
    de: 'Hast Du schon einen Account?',
    en: 'Do you already have an account?'
  },
  REGISTER_LOGIN_OR_REGISTER_TITLE: {
    de: 'Login/ Registrierung',
    en: 'Login/ Register'
  },
  REGISTER_USER_DATA_TITLE: {
    de: 'Registrierung',
    en: 'Register'
  },
  REGISTER_USER_DATA_MESSAGE: {
    de: 'Bitte wähle Deinen persönlichen Nutzernamen und Dein Passwort für den Zugang.',
    en: 'Please choose your personal username and your password'
  },
  SCAN_QR_CODE: {
    de: 'QR-Code scannen',
    en: 'Scan QR Code'
  },
  // --------------------
  // -- ERROR MESSAGES --
  // --------------------
  E_RESET_TOO_LATE: {
    de: 'Du hast Die Rücksetzanfrage zu spät bestätigt. Bitte versuche es erneut.'
  },
  E_USER_DUPLICATE: {
    de: 'Username ist nicht bekannt.'
  },
  E_USERNAME_EMPTY: {
    de: 'Bitte geben Sie einen Usernamen an.'
  },
  E_DEVICEUUID_EMPTY: {
    de: 'Die Device-ID ist leer'
  },
  E_DEVICEUUID_WRONG: {
    de: 'Die Device-UUID hat das falsche Format'
  },
  E_DEVICE_NOTOWNED: {
    de: 'Der Username ist für dieses Gerät nicht registriert.'
  },
  E_USER_NOTFOUND: {
    de: 'Unbekannter Username.'
  },
  E_DEVICE_NOTFOUND: {
    de: 'Diese Device UUID ist nicht angemeldet.'
  },
  E_DEVICE_LOCKED: {
    de: 'Device gesperrt.'
  },
  E_MUST_REVALIDATE: {
    de: 'Neue Anmeldung erforderlich.'
  },
  E_MUST_ACTIVATE: {
    de: 'Neue Aktivierung erforderlich.'
  },
  E_PIN_LOCKED: {
    de: 'Du hast das Zurücksetzen deines Passworts beantragt. Bitte warte bis dich dein Spielleiter freischaltet.'
  },
  E_FIRSTNAME_EMPTY: {
    de: 'Kein Vorname angegeben.'
  },
  E_FIRSTNAME_WRONG: {
    de: 'Vorname hat ein falsches Format.'
  },
  E_LASTNAME_EMPTY: {
    de: 'Kein Nachname angegeben.'
  },
  E_LASTNAME_WRONG: {
    de: 'Nachname hat das ein falsches Format.'
  },
  E_USERID_EMPTY: {
    de: 'Keine Userid angegeben.'
  },
  E_USERID_NOTFOUND: {
    de: 'Userid ist nicht bekannt.'
  },
  E_WRONG_RECREATE: {
    de: 'User existiert bereits.'
  },
  E_PASSWORD_SHORT: {
    de: 'Passwort zu kurz.'
  },
  E_USER_NOTSAVED: {
    de: 'User konnte nicht angelegt werden.'
  },
  E_DEVICE_NOTSAVED: {
    de: 'Device konnte nicht angelegt werden.'
  },
  E_PERSONALIZATION_NOT_REQUIRED: {
    de: 'Keine Personalisierung erforderlich.'
  },
  E_CODE_EMPTY: {
    // de: 'Bitte einen Gruppencode angeben.'
    de: 'Bitte einen Gruppennamen angeben.'
  },

  /**
   * Dieser Fehlermeldung kommt bei falschem Format. Um den Nutzer nicht zu verwirren (es wurde nach einem Gruppennamen
   * gefragt), sagen wir hier einfach, dass der Gruppenname unbekannt sei. Damit wir aber unterscheiden können, ob es ein
   * Formatfehler ist oder wirklich ein unbekannte Code, steht am Ende noch ein Smiley.
   */
  E_CODE_WRONG: {
    // de: 'Gruppencode mit falschem Format angegeben.'
    de: 'Dieser Gruppenname ist unbekannt :-('
  },
  E_CODE_TOO_EARLY: {
    de: 'Das Quiz hat für diese Personalnummer noch nicht begonnen.'
  },
  E_CODE_TOO_LATE: {
    de: 'Das Quiz ist für diese Personalnummer beendet.'
  },
  E_CODE_REVOKED: {
    // de: 'Die App ist für diesen Gruppencode nicht mehr verfügbar.'
    de: 'Die App ist für diese Gruppe nicht mehr verfügbar.'
  },
  E_APP_NEEDSUPDATE: {
    de: 'Bitte update deine App.'
  },
  E_APP_OUTDATED: {
    de: 'Das Quiz wurde aktualisiert, zum Weiterspielen installieren sie bitte eine neuere Version der App aus dem Store.'
  },
  E_CODE_IN_USE: {
    de: 'Dieser Code wird bereits benutzt.'
  },
  E_CODE_EXPIRED: {
    de: 'Die Gültigkeit dieses Codes ist abgelaufen. Bitte wenden Sie sich an Ihren Ansprechpartner.'
  },
  E_CODE_TOO_MANY_USERS: {
    // de: 'Zu viele Nutzer für diesen Gruppencode'
    de: 'Zu viele Nutzer für diese Gruppen'
  },
  E_OLDPASSWORD_SHORT: {
    de: 'Existierendes Passwort zu kurz.'
  },
  E_NEWPASSWORD_SHORT: {
    de: 'Neues Passwort zu kurz.'
  },
  E_PASSWORD_NOTMATCH: {
    de: 'Das eingegebene Passwort ist leider falsch.'
  },
  E_PIN_REQUESTCODE: {
    de: 'Allgemeiner Fehler.)'
  },
  E_NO_EMAIL: {
    de: 'Zu diesem User ist keine E-Mail-Adresse bekannt.'
  },
  E_INVALID_EMAIL: {
    de: 'Die E-Mail-Adresse ist ungültig.'
  },
  E_INVALID_TOKEN: {
    de: 'Ungültiges Token.'
  },
  E_INVALID_SIGNATURE: {
    de: 'Ungültige Signatur der Nachricht.'
  },
  E_INVALID_PATH: {
    de: 'Link / Pfad ungültig.'
  },
  E_TOKEN_USED: {
    de: 'Dieses Token wurde bereits benutzt.'
  },
  E_TIMERANGE_EXPECTED: {
    de: 'Fehlender Zeitraum.'
  },
  E_FEATURE_NOTFOUND: {
    de: 'Unbekanntes Feature.'
  },
  E_NOT_CONFIRMED: {
    de: 'Rücksetzanfrage nicht bestätigt.'
  },
  E_REQUEST_EXPIRED: {
    de: 'Rücksetzanfrage ausgelaufen.'
  },
  E_WRONG_CODE_CREATION: {
    de: 'Allgemeiner Fehler.'
  },
  E_NOTAGREED: {
    de: 'Nutzungsbedingungen nicht zugestimmt.'
  },
  E_GROUP_NOTFOUND: {
    de: 'Keine Spielgruppe gefunden.'
  },
  E_QUIZUSER_NOTSAVED: {
    de: 'Der Quizuser konnte nicht angelegt werden.'
  },
  E_NETWORK_ERROR: {
    de: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.'
  },
  E_NETWORK_TIMEOUT: {
    de: 'Der Server antwortet nicht. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.'
  },
  E_OFFLINE_POST: {
    de: 'Du bist nicht online. Um weiter zu spielen, gehe bitte online.'
  },
  E_RUNNING_GAME: {
    de: 'Der Spieler hat bereits ein neues Spiel gegen dich gestartet.'
  },
  E_MANIPULATED: {
    de: 'Es gibt bereits ein neueres Spiel auf dem Server. Bitte update deine Spielliste.'
  },
  E_NICKNAME_WRONG_FORMAT: {
    de: 'Der Spielername enthält ein nicht-erlaubtes Zeichen.'
  },
  E_NICKNAME_USED: {
    de: 'Der Spielername ist bereits vergeben.'
  },
  E_NICKNAME_EMPTY: {
    de: 'Bitte trage einen Spielernamen ein.'
  },
  E_ALL_SEASON_CLOSED: {
    de: 'Es gibt keine laufende Saison.'
  },
  E_NO_MORE_GAMES_WITH_OPP: {
    de: 'Du hast bereits alle Spiele gegen diesen Gegner absolviert.'
  },
  E_HTTP_STATUS: {
    de: "Oops! Da ist wohl etwas schiefgegangen.<br />Entschuldigung!"
  },
  E_INSUFFICIENT_PERMISSION_SAFETURE: {
    de: "Es sind alle Berechtigungen vorhanden, die f\xFCr das vollst\xE4ndige Funktionieren dieser App ben\xF6tigt werden.",
    en: "Not all permissions have been granted that are necessary for this app to work as expected."
  },
  E_UNKNOWN_ERROR: {
    de: 'Ein unbekannter Fehler ist aufgetreten.'
  },
  E_UNKNOWN_ERROR_WITH_REASON: {
    de: 'Ein unbekannter Fehler ist aufgetreten: $0',
    en: 'An unknown error occured: $0'
  },
  BROWSER_HINT_TITLE: {
    de: 'Hinweis',
    en: 'Note'
  },
  BROWSER_HINT_COPY: {
    de: 'Du benutzt einen Browser, auf dem diese Applikation nicht getestet wurde oder der veraltet ist. Es kann ein Sicherheitsrisiko sein, veraltete Webbrower zu nutzen. Sie können trotzdem weitermachen aber vielleicht wird das eine oder andere Feature nicht so funktionieren wie es sollte. Bitte benutzen Sie einen aktuellen IE, Firefox, Safari oder Chrome Browser.',
    en: 'You are using a browser on which this application has not been tested or is out of date. It can be a security risk to use outdated web browsers. You can still go on, but maybe one or the other feature will not work as it should. Please use a current IE, Firefox, Safari or Chrome browser.'
  },
  E_NO_VALIDATION_CODE_ENTERED: {
    de: 'Bitte geben Sie einen Validierungscode ein.',
    en: 'Please enter a validation code.'
  },
  CONNECT_ALREADY_CONNECTED: {
    de: 'Sie sind schon verbunden'
  },
  PLEASE_NOTE: {
    de: 'Hinweis'
  },
  CHECK: {
    de: 'Überprüfen',
    en: 'Check'
  },
  FEATURE_INACTIVE: {
    de: 'Feature inaktiv'
  },
  E_SAFETURE_INVALID_CODE: {
    de: 'Ungültiger Validierungscode. Bitte versuche es noch einmal.',
    en: 'Invalid validation code. Please try again.',
    it: 'Codice non valido. Prova di nuovo.'
  },
  // SNOO
  SHOW_NEXT_SNOO: {
    de: 'Nächstes Nugget anzeigen'
  },
  ALL_READ: {
    de: 'Alles gelesen'
  },
  OCLOCK: {
    de: 'Uhr'
  },
  ABOUT_THIS_APP: {
    de: 'Über diese App',
    en: 'About this app'
  },
  OFFLINE_TITLE: {
    de: 'Offline',
    en: 'Offline'
  },
  MORE_INFOS: {
    de: 'Zum Inhalt'
  },
  SETTINGS_LOG_OUT_MESSAGE: {
    de: 'Möchten Sie alle lokal gespeicherten Daten jetzt löschen? Ihr Spielstand geht dadurch nicht verloren.'
  },
  SETTINGS_LOG_OUT_TITLE: {
    de: 'Ausloggen'
  },
  // SCHICHTBOX
  SCHICHTBOX_SET_EARLY_PUSH_TIME: {
    de: 'Tagesbotschaft'
  },
  SCHICHTBOX_SET_LATE_PUSH_TIME: {
    de: 'Tagesfazit'
  },
  UNLOCK_ADDITIONAL_FEATURE: {
    de: 'Zusätzliche Inhalte freischalten'
  },
  UNLOCK_ADDITIONAL_FEATURE_TEXT: {
    de: 'Bitte geben Sie den Aktivierungscode zum Freischalten weiterer Inhalte ein.'
  },
  RESET_DEMO: {
    de: 'Demo zurücksetzen'
  }
  /**
   * Please don't add any non-generic strings to this list but rather copy strings_template.js from this folder
   * to your components folder and add the string there.
   */

}; // THIS IS SOURCE CODE BELOW THIS LINE
// ------------------------------------------------------------------------------------------------------------------

var onLanguageChangedFn = null;
/**
 * This function is meant to be called from lower strings.js with the strings object defined in there.
 *
 * If a key in stringsObject is already available in the existing keys, an exception is thrown in printed to the console.
 * If so, the app will stop working if build in debug mode and overwrite the existing key if build in prod mode.
 *
 * @param stringsObject
 */

var addStrings = function addStrings(stringsObject) {
  console.log('adding strings', stringsObject); // just merge in prod mode

  if (_BuildConstants.NODE_ENV === 'production') {
    var countBefore = (0, _keys["default"])(STRINGS).length;
    var countToAdd = (0, _keys["default"])(stringsObject).length;
    STRINGS = (0, _assign["default"])(STRINGS, stringsObject);
    var countAfter = (0, _keys["default"])(STRINGS).length;

    if (countAfter < countBefore + countToAdd) {
      var error = "Added strings to global string list but at least one key was present before and overwritten now: ".concat((0, _stringify["default"])((0, _keys["default"])(STRINGS)), ", ").concat((0, _stringify["default"])(stringsObject));
      console.log('error adding strings: ', error);
      (0, _LogService.pushErrorMessage)('n/a', error);
    }

    return;
  } // make deeper check in development mode


  var existingKey = (0, _keys["default"])(stringsObject).find(function (key) {
    return STRINGS[key];
  });

  if (existingKey) {
    console.error('Error adding strings to global string list: Key already exists.', existingKey);
    (0, _MuiAlertHelper.showAlertWithOptions)({
      debugModeOnly: true,
      title: 'Error',
      message: "Duplicate key tried to add to strings: ".concat(existingKey, "! No duplicate keys allowed. Please fix this.")
    });
  }

  STRINGS = (0, _assign["default"])(STRINGS, stringsObject);
};

exports.addStrings = addStrings;

var applyArgsToString = function applyArgsToString(string, args) {
  if (!args || args.length === 0 || !(0, _isArray["default"])(args)) {
    if (typeof args === 'string') {
      args = [args];
    } else {
      return string;
    }
  }

  var stringWithAppliedArgs = string;
  var i = 0;
  args.forEach(function (arg) {
    stringWithAppliedArgs = stringWithAppliedArgs.replace("$".concat(i), arg);
    i += 1;
  });
  return stringWithAppliedArgs;
};

var setCurrentLanguage = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(langCode) {
    var langCodeToUse;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            langCodeToUse = langCode || (_config["default"].supportedLanguages && _config["default"].supportedLanguages.length > 0 ? _config["default"].supportedLanguages[0] : 'en');
            console.log('setting current language to', langCodeToUse);
            CURRENT_LANG = langCodeToUse;

            if (_DeviceInfoHelper["default"].isBrowser()) {
              _context.next = 16;
              break;
            }

            _context.prev = 4;
            console.log('readTextFile setCurrentLanguage');
            _context.t0 = JSON;
            _context.next = 9;
            return _CordovaFileHelper["default"].readTextFile("strings/".concat(langCodeToUse, ".json"), _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

          case 9:
            _context.t1 = _context.sent;
            CROWDIN_STRINGS = _context.t0.parse.call(_context.t0, _context.t1);
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t2 = _context["catch"](4);
            console.warn("error changing language to ".concat(langCodeToUse, " (ignore in single language apps or at app start)"), _context.t2);

          case 16:
            if (onLanguageChangedFn) {
              onLanguageChangedFn();
            }

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 13]]);
  }));

  return function setCurrentLanguage(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.setCurrentLanguage = setCurrentLanguage;

var getCurrentLanguage = function getCurrentLanguage() {
  return CURRENT_LANG;
};

exports.getCurrentLanguage = getCurrentLanguage;

var reloadStrings = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", setCurrentLanguage(CURRENT_LANG));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function reloadStrings() {
    return _ref2.apply(this, arguments);
  };
}();

exports.reloadStrings = reloadStrings;

var setOnLanguageChangedFn = function setOnLanguageChangedFn(fn) {
  onLanguageChangedFn = fn;
};
/**
 * Returns the string for the requested key in the preferred language.
 * If it is not found all languages of higher priority are checked (as specified in config or target config).
 * If not present there either the key itself will be returned
 *
 * If no preferred language is given, the current language is used.
 * If even a current language is not set, the first language as specified in config or target config is used.
 *
 */


exports.setOnLanguageChangedFn = setOnLanguageChangedFn;

var getString = function getString(key) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var preferredLanguage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  // const getDefaultString = (key, args) => {
  //   if (!args || args.length > 0) {
  //     return `${key} (${JSON.stringify(args)})`
  //   }
  //   return key
  // }
  // if no lang code is given use the target language
  if (!preferredLanguage) {
    preferredLanguage = CURRENT_LANG || _config["default"].supportedLanguages[0];
  }

  var defaultStringsForKey = STRINGS[key];
  var targetStringsForKey = _strings["default"] && _strings["default"][key] ? _strings["default"][key] : {}; // get Strings for preferred Language out of translation file

  var onlineStringsForKey = CROWDIN_STRINGS && CROWDIN_STRINGS[key] ? CROWDIN_STRINGS[key] : {}; // console.log('onlineStringsForKey', key, onlineStringsForKey, CURRENT_LANG, CROWDIN_STRINGS)
  // merge strings (e.g. if some languages only exist in target strings)

  var strings = (0, _assign["default"])({}, defaultStringsForKey, targetStringsForKey, onlineStringsForKey); // check if string exists in preferred language

  if (typeof strings[preferredLanguage] === 'string') {
    // it might be an empty string
    return applyArgsToString(strings[preferredLanguage], args);
  } // find best language


  var bestAvailLanguage = _config["default"].supportedLanguages.filter(function (language) {
    return (0, _keys["default"])(strings).indexOf(language) >= 0;
  });

  if (bestAvailLanguage.length > 0) {
    bestAvailLanguage = bestAvailLanguage[0];
  } // check if string exists in preferred language


  if (strings[bestAvailLanguage]) {
    return applyArgsToString(strings[bestAvailLanguage], args);
  } // if (target.allowEmptyStrings) {
  //   return ''
  // }


  return key;
};

exports.getString = getString;